<template>
    <div class="container">
        <router-view />
    </div>
</template>

<script>
    export default {
        name: "logistics",
        data() {
            return {}
        },
        methods:
            {},
        created() {
        },
    }
</script>

<style lang="scss" scoped>
.container{
    width: 100%;
    height: 100%;
}
</style>